import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import logoIcon from '@/assets/logo-icon.webp';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen flex w-full bg-background overflow-x-hidden">
      <Sidebar />
      <main className="flex-1 lg:ml-0 pb-24 lg:pb-0 min-w-0">
        {/* Mobile Header with branding */}
        <div className="lg:hidden flex items-center gap-2.5 px-4 pt-4 pb-2">
          <img src={logoIcon} alt="Review Plum" className="w-9 h-9 object-contain" />
          <div className="flex flex-col leading-tight">
            <span className="font-bold text-sm text-foreground">Review</span>
            <span className="font-bold text-sm text-primary">Plum</span>
          </div>
        </div>
        <div className="page-container pt-2 lg:pt-6 px-4 lg:px-6">
          {children}
        </div>
      </main>
      <MobileNav />
    </div>
  );
}
